import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserCvAction,
  profilImageUserAction,
} from "../../Actions/UserAction/UserAction";
import { useParams } from "react-router-dom";

const UserProfile = () => {
  const { userId } = useParams();
  const [tempImageId, setTempImageId] = useState(null);

  const getUserCv = useSelector((state) => state.getUserCv);
  const { userCvs } = getUserCv;
  const profileUser = useSelector((state) => state.profileUser);
  const { profile, loading } = profileUser;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUserCvAction(userId));
  }, [dispatch]);
  useEffect(() => {
    userCvs
      ?.filter((filter) => filter.profile == 1)
      .map((cv) => {
        setTempImageId(cv.id);
      });
  }, [userCvs]);
  const handleChangeProfile = (id) => {
    
    let ids = userCvs?.map((cv) => cv.id);
    if (ids.length > 0) {
      dispatch(profilImageUserAction(ids, id));
    }
  };
  return (
    <div className="p-6 mx-auto max-w-screen-lg">
      <h1 className="text-3xl font-bold mb-6 text-center text-gray-800">
        Image Gallery
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {userCvs?.map((image) => {
          return (
            <div key={image.id} className="relative group">
              <img
                src={image.image}
                // alt={image.alt}
                className="w-full h-48 object-cover rounded-lg shadow-lg transition-transform duration-300 transform group-hover:scale-105"
              />
              <button
                onClick={() => {
                  setTempImageId(image.id);
                  handleChangeProfile(image.id);
                  // console.log(image.id)
                }}
                disabled={loading}
                className={`absolute bottom-4 right-4 px-4 py-2 rounded-full text-white font-bold transition-colors duration-300 ${
                  loading ? "cursor-not-allowed bg-opacity-50" : ""
                } ${
                  tempImageId === image.id
                    ? "bg-green-500 hover:bg-green-600"
                    : "bg-blue-500 hover:bg-blue-600"
                }`}
              >
                {tempImageId === image.id
                  ? "Set as Profile"
                  : "Profile Picture"}
                  {/* {image.id} */}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UserProfile;
